import { RequestHandler } from 'express';

import { saveRecorded } from '~/app/mockingMiddleware';
import { MigrateRequest } from '~/services';

import EntriesMigrationService from '~/services/EntriesMigrationService';
import mapAppErrorToObject from '~/transformations/mapAppErrorToObject';

export const deleteContentAssets: RequestHandler = async (req, res) => {
  try {
    const {
      payload,
      preview,
    }: {
      payload?: MigrateRequest;
      preview?: boolean;
    } = res.locals;

    const migrationService = new EntriesMigrationService(
      payload as MigrateRequest,
      preview as boolean
    );

    const results = await migrationService.DeleteAssetEntries();
    const response = { committed: !preview, ...results };

    res.send(response);

    saveRecorded(req, res, {
      operation: 'deleteAssetEntries',
      response,
    });
  } catch (ex: any) {
    res.status(500).send({ error: mapAppErrorToObject(ex) });
  }
};

export const migrateContentAssets: RequestHandler = async (req, res) => {
  try {
    const {
      payload,
      preview,
      download,
    }: {
      payload?: MigrateRequest;
      preview?: boolean;
      download?: boolean;
    } = res.locals;

    const migrationService = new EntriesMigrationService(
      payload as MigrateRequest,
      preview as boolean,
      download
    );

    const results = await migrationService.MigrateContentAssets();
    const response = { committed: !preview, ...results };

    res.send(response);

    saveRecorded(req, res, {
      operation: 'migrateContentAssets',
      response,
    });
  } catch (ex: any) {
    res.status(500).send({ error: mapAppErrorToObject(ex) });
  }
};
